import React from "react";
import { Form } from "react-bootstrap";
import { useField, useFormikContext } from "formik";
import { withTranslation } from "react-i18next";
import Select from "react-select";
import {selectCustomStyle} from '../../styles/selectCustomStyle';

const FormikCompanyTypePicker = ({ ...props }: any) => {
  const { t } = props;
  const formikProps = useFormikContext<any>();
  const [field] = useField(props);

  const getValidTypes = () => {
    const result = [];
    if(props.emptyOption){
      result.push(['', ''])
    }
    result.push([1, t("Toiminimi")]);
    result.push([2, t("Kommandiittiyhtiö")]);
    result.push([3, t("Avoin yhtiö")]);
    result.push([4, t("Osakeyhtiö")]);
    return result;
  };

  const handleChange = async (value: any) => {
    formikProps.setFieldError(field.name, "");
    await formikProps.setFieldValue(field.name, value ? Number(value) : value);
  };

  const isInvalid = Boolean(!!formikProps.errors[field.name] && formikProps.touched[field.name]);

  const exitingValue = getValidTypes().find((option) => option[0] === field.value);

  return (
    <Form.Group className={"FormikCompanyTypePicker form-group"}>
      {props.title !== undefined ? <Form.Label>{props.title}</Form.Label> : null}
      <Select
        options={getValidTypes().map(option => ({value: option[0], label: option[1] }))}
        onChange={(newValue) => newValue && handleChange(newValue.value)}
        value={exitingValue ? { value: exitingValue[0], label: exitingValue[1] } : { value: 0, label: ""}}
        className={isInvalid ? "is-invalid" : "is-valid"}
        onBlur={formikProps.handleBlur}
        styles={selectCustomStyle(isInvalid)}
      />
      <Form.Control.Feedback type="invalid">
        {String(formikProps.errors[field.name]) ?? undefined}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default withTranslation("translations")(FormikCompanyTypePicker);
